<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="cnes-generico-incompativel"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="currentGrid" [gridKey]="currentGridKey" class="mr-2"></ag-views-toolbar>
      <bl-competencia
        class="mr-2"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="mr-4 p-button p-button-md"
        [ngClass]="{ 'p-disabled': tabIndex === TAB_INCOMPATIVEL ? !filterChangedIncompativel : !filterChangedGenerico }"
        [disabled]="tabIndex === TAB_INCOMPATIVEL ? !filterChangedIncompativel : !filterChangedGenerico"
        (click)="reloadData()"
      ></button>

      <bl-pesquisar-input
        class="ml-2 mr-2"
        (onSearch)="onSearch($event)"
        [disabled]="!rowDataGenerico?.length && !rowDataIncompativel?.length"
      ></bl-pesquisar-input>

      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="tabIndex === TAB_INCOMPATIVEL ? !rowDataIncompativel?.length : !rowDataGenerico?.length"
      >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="grid-wrapper">
    <p-tabs [(value)]="tabIndex" (valueChange)="onTabChange()">
      <p-tablist>
        <p-tab [value]="TAB_GENERICO">Guias com CNES genérico</p-tab>
        <p-tab [value]="TAB_INCOMPATIVEL">Guias com CNES incompatível</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="TAB_GENERICO">
          <ag-grid-angular
            #agGridGenerico
            data-smartpresentation="ag-grid"
            class="ag-theme-balham w-full"
            [rowData]="rowDataGenerico"
            [gridOptions]="gridOptionsGenerico"
            [overlayLoadingTemplate]="firstLoadGenerico ? 'Clique em Pesquisar para exibir os registros' : null"
          >
          </ag-grid-angular>
        </p-tabpanel>
        <p-tabpanel [value]="TAB_INCOMPATIVEL">
          <ag-grid-angular
            #agGridIncompativel
            data-smartpresentation="ag-grid"
            class="ag-theme-balham w-full"
            [rowData]="rowDataIncompativel"
            [gridOptions]="gridOptionsIncompativel"
            [overlayLoadingTemplate]="firstLoadIncompativel ? 'Clique em Pesquisar para exibir os registros' : null"
          >
          </ag-grid-angular>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <div class="grid-footer">
      <small>Último processamento em: {{ dtUltimoProcessamento || '-' }}</small>
    </div>
  </div>
</bl-page-card-container>
